module.exports = __webpack_public_path__ + "img/chevron-right.6fefa7a4.svg";